import Backbone from '../classes/backbone';
import UIProps from '../classes/uiprops';
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
   
   let backboneBlock = '.backbone-block';
   //let goTo = '.backbone-goto';
   let blockSliders = '.slider-holder .block-slider';
   let activeBlock = '.backbone-block.active';
   let resDiv = '.backbone-res';
   let $steps = $('.steps');
   let $backboneContainer = $('.backbone-container');


   // eslint-disable-next-line no-undef
   let obj = content;
   let options = {
      ajaxUrl    :  obj.ajax_url,
      ajaxNonce  :  obj.ajax_nonce,
      ajaxMethod :  'am_a_proud_virgin',
      elements   :  obj.backbone_elements,
      feedback_content : obj.feedback_content,
   };

   let backbone = new Backbone(options);
   let backboneEls = backbone.elements;

   var uiProps = new UIProps({
     completed: 0,
     totalElements : backbone.getElementCount(),
   });


   $('.conclusion-block').on('click', () => $(document).trigger('resizeBackboneContainer', [500]) );

  $(document).find('.backbone-learn-more').on('change', () => console.log('learn more has changed'));
  $(document).find('.backbone-collapse').on('change', () => console.log('collapse has changed'));

   setup();
   function setup() {
    setTimeout(() => $(document).trigger('resizeBackboneContainer', [1250]), 1250);
   }

   $(window).resize(() => $(document).trigger('resizeBackboneContainer'));

   $(document).on('resizeBackboneContainer', function(e, delay = 0, extraHeight = 0) {
     resizeBackboneContainer(delay, extraHeight);
   });
   
   function resizeBackboneContainer(delay = 0, extraHeight = 0) {
    setTimeout(() => {
      var $innerHeight = parseInt($backboneContainer.find('.row__conclusion-nav').outerHeight()) + parseInt($backboneContainer.find('.backbone-block.active').outerHeight()) + parseInt($backboneContainer.find('.remaining-items-container').outerHeight());
       $innerHeight += typeof extraHeight === "number" ? extraHeight : 0;    	
      $backboneContainer.css('height', ($innerHeight + 'px'));  
    }, delay);
   }
   $('.backbone-learn-more').on('click', function(e){

    e.preventDefault();
    let isNotExpanded = !$(this).hasClass('expanded');
    let isExpanded = $(this).hasClass('expanded');
    let $collapse = '#readMore' + $(this).data('id');
    let $newHeight = parseInt($($collapse).find('> div').height()) + 70;

    console.log($collapse);
    
    if(isNotExpanded) {
      $(this).addClass('expanded');
      $($collapse).css('height', $newHeight + 'px');
      !$($collapse).hasClass('animate-in') ? $($collapse).addClass('animate-in') :  '';
      $(document).trigger('resizeBackboneContainer', [250, (70)]);
    } else if(isExpanded) {
      $(this).removeClass('expanded');
      $($collapse).css('height', 0 + 'px');
      $(document).trigger('resizeBackboneContainer', [250, (-60)]);
    }

   });
   

   function uiPropCheck() {
     uiProps.update("completed", backbone.getCompletedCount());
     markCompletedItems();
   }

   function markCompletedItems() {
    for(var i = 0; i < backboneEls.length; i++) {
      if(backboneEls[i].isComplete){
        $('.selection-list__item' + '[data-id="'+backboneEls[i].ID+'"]').addClass('complete');
      } else {
        $('.selection-list__item' + '[data-id="'+backboneEls[i].ID+'"]').removeClass('complete')
      }
    }
    return;
   }


   $(document).on('click', '.backbone-goto', function(e){
     e.preventDefault();
     let $blockID = $(this).data('goto');
     goToBlock($blockID);
     console.log($blockID)
   });

    /*
     * Loop thru the elements and implement a rudementiary action
     */
    function goToBlock($blockID) {
      
      //DO WIPE 
      wipeUp(
        () => { 
          elementBlock().onExit();
          scrollTo('.container-assessment');  
        },
        () => { 
          $(backboneBlock).removeClass('active');
          $(backboneBlock).removeClass('animate-in');
          $(backboneBlock + '[data-id="'+ $blockID +'"]').addClass('active');
          setTimeout(function() {
            $(backboneBlock + '[data-id="'+ $blockID +'"]').addClass('animate-in');  
          }, 150);
          hideRemainingItemsPreview();
          scrollTo('.container-assessment');
          elementBlock().onEntry();
          clearWipe();
          $(document).trigger('resizeBackboneContainer');
        }, 1250
      );
      
    }

    //actions to perform on entry and exit of an element block
    function elementBlock() {
      return {
        onExit: () => {
          setTimeout(() =>  $('.row__conclusion-nav').addClass('out'), 500);
          let $activeBlock = $('.backbone-element.active');
          $activeBlock.find('.slider-holder .block-slider .ui-slider-handle').removeClass('normal-transition');
          $activeBlock.find('.slider-holder').removeClass('normal-transition');
          $activeBlock.find('img').removeClass('normal-transition');
        },
        onEntry: () => {
          setTimeout(() => $('.row__conclusion-nav').removeClass('out'), 750);
          setTimeout(() => {
            let $activeBlock = $('.backbone-element.active');
            $activeBlock.find('.slider-holder .block-slider .ui-slider-handle').addClass('normal-transition');
            $activeBlock.find('.slider-holder').addClass('normal-transition');
            $activeBlock.find('img').addClass('normal-transition');
          }, 3000);
        },
      };
    }

    function wipeUp(whilst, then, withDelay = 1000) {
      $(backboneBlock + '.active').find('.wipe-up').addClass('active');
      whilst();
      setTimeout(() => then(), withDelay );
    }

    function clearWipe() {
      $('.wipe-up').removeClass('active');
    }



    function scrollTo(selector, offset = 0) {
       if(selector) {
         $('html, body').animate({scrollTop:$(selector).offset().top + offset}, 450); 
       } else {
        return;
      }
    }    

    function bindResultsToView(feedback, negatives, doReturn = false){
      $(activeBlock).find(resDiv).html(feedback.message);

      var markup = generateMarkup(feedback, negatives);

      if(!doReturn) {
        fillWithRes(markup);
      } else {
        return markup;
      }

    }

    function fillWithRes(markup) {
      $('.backbone-block.active .backone-res').addClass('with-border');  
      $('.backbone-block.active .backone-res').html(markup);
      
      setTimeout(function(){
        if(!$('.backbone-block.active .backone-res').hasClass('filled')){
          scrollTo('.backbone-block.active .backone-res');
          $('.backbone-block.active .backone-res').addClass('filled');  
        }
      }, 1000);  
      $(document).trigger('resizeBackboneContainer', [1550]);

    }

    function generateMarkup(feedback, negatives) {
      var negativeMarkup = '<div><ul>';
      negatives.map(neg => {
        negativeMarkup += '<li>' + neg.negative_selection.name + '</li>';
      });
      negativeMarkup += '</div></ul>';

      var markup  = '<div>';
          markup +=    '<img src="' + feedback.image + '"/>';
          markup +=    '<h2>' + feedback.message + '</h2>';
          markup +=    negativeMarkup ? negativeMarkup : '';
          markup += '</div>';
      return markup;     
    }



    function showFinalRes() { 
      $('.col-r').addClass('conclusion');
      var markup = '<div class="element-conclusion-block">';
          backboneEls.map(el => {
           var readMore = '<a class="backbone-learn-more" data-toggle="collapse" href="#conclusionReadMore'+el.ID+'" aria-expanded="false" aria-controls="conclusionReadMore'+el.ID+'">Read More <i></i></a>';
           var backboneReadMore  = '<div class="backbone-cta collapse" id="conclusionReadMore'+el.ID+'" >';
               backboneReadMore += '<p>'+ el.read_more_content +'</p>';
               backboneReadMore += '<a class="btn btn-primary btn-icn btn-icn__right"href="'+el.read_more_url+'"target="_blank"> <span>Learn More</span> <i style="font-weight: 400;" class="icon-arrow-right"></i> </a>';
               backboneReadMore += '</div>';
           markup += '<div class="element-conclusion-block__element-result">';
              markup += '<h2>'+ el.post_title +':</h2>';
              markup += bindResultsToView(el.generateFeedback(), el.listAllOfType('negative'), true );
              markup += readMore;
              markup += backboneReadMore;
           markup += '</div>';
          });
      markup += '</div>';
      $('.conclusion-res').html(markup);
    }

    function hideFinalRes() {
      $('.conclusion-res').html('');
      $('.col-r').removeClass('conclusion');
    }


    $steps.find('#completed').on('mouseenter', function(){
      highlightItems('complete');
    }).on('mouseleave', function() {
      highlightItems('complete');
    });

    $steps.find('#totalElements').on('mouseenter', function(){
      highlightItems('incomplete');
    }).on('mouseleave', function() {
      highlightItems('incomplete');
    });    
    
    //blur out the items so that you can highlight the items you wanna show
    function highlightItems(type = 'incomplete') {
      switch(type) { 
        case 'complete': 
          $('.selection-list__item:not(.complete)').toggleClass('blur');          
          break;
        case 'incomplete':
          $('.selection-list__item.complete').toggleClass('blur');
          break;
      }
    }



    function clearResultsFromView() {
      $('.backbone-block.active .backone-res').html('');
    }

    $(blockSliders).slider({
        min: 0,
        range: false,
        max: 1,
        value: 0,
        animate: "slow",
        orientation: "horizontal",
        slide: function(event, ui) {
            //bind ui response to big elements block 
            var selectionID = $(ui.handle).parent().parent().data('id');
            updateSlider(selectionID, ui.value, event);
            //console.log(selectionID);
            console.log(ui);

        },
        create: function( event ) {
          $(event.target).find('> span').css('left', '50%');
        },
    });
   

    

    $('.selection-slider__selection span').on('click', function() {
       
       var $selectionID = $(this).data('id');
       var $value = $(this).data('value');
       var event = null;
       var $target = $('.backbone-element.active .selection-slider[data-id="'+ $selectionID +'"] .selection-slider__slider .slider-holder .block-slider');
       var $id = $selectionID;
       
       updateSlider($selectionID, $value, event, $target, $id);

    });

    $('.invisible-selector').on('click', function() {
      var $selectionID = $(this).data('id');
      var $value = $(this).data('value');
      var event = null;
      var $target = $('.backbone-element.active .selection-slider[data-id="'+ $selectionID +'"] .selection-slider__slider .slider-holder .block-slider');
      var $id = $selectionID;
      updateSlider($selectionID, $value, event, $target, $id);
    })



    function updateSlider(selectionID, value, event, target = null, id = null){
        doActiveBlockAction(function(el) {
           
           el.updateSelection(selectionID, value);
           var $id;
           var $target;
           let firedFromSliderEvent = event !== null && target == null && id == null || false;

           if(firedFromSliderEvent) {
            $id = $(event.target).parent().data('id');
            $target = $(event.target);  
           } else {
            $id = id;
            $target = target;
            var $el = $('.backbone-element.backbone-block.active .selection-slider[data-id="'+ $id +'"]');
            $el.find('.block-slider').slider("value", value); 
           }


           if(value !== "undefined" && value !== null) {
            updateSliderUI($id, $target, value);
           } else {
            console.log(event);
           }

           //bind result to view if validation passes else clear result from view
           if (el.passesValidation()){ 
             bindResultsToView( el.generateFeedback(), el.listAllOfType('negative'));

             backbone.isComplete() ? showFinalRes() :  hideFinalRes();


             $('.backbone-element.active .backbone-learn-more').addClass('active');
           } else {
             clearResultsFromView();
           }
           uiPropCheck();
        });	
    }


    let nextItem = () => {
       var goToID;
       let incompleteEls = backbone.getIncompletedElements();
       let $activeBlockID = $('.backbone-element.active').data('id');

       for(var i = 0; i < incompleteEls.length; i++){
         if(incompleteEls[i].ID !== $activeBlockID){
           goToID = incompleteEls[i].ID;
         }
       }

       goToBlock(goToID);       
    }
    
    $('.start-over').on('click', (e) => {
      e.stopImmediatePropagation();
      location.reload(true);
    });

    $('.row__conclusion-nav .col-r').on('click', () => !$(this).hasClass('conclusion') && nextItem() );

    $('.row__conclusion-nav .remaining-items-nav').on('click', function(e) {
       e.preventDefault(); 
       e.stopImmediatePropagation();
       nextItem();
    });

    /*$('.col-r').on('hover', function(){
      if(!backbone.isComplete()){
        showRemainingItemsPreview();  
      }
    });*/
    /*function showRemainingItemsPreview() {
      if(!$('.remaining-items-container').hasClass('show-remaining-items')) {
        
        var remainingItemsHTML = '';
        var count = 0;

        backbone.getIncompletedElements().map(el => {
          if(el.ID !==  $('.backbone-element.active').data('id')) {
           count++;
           remainingItemsHTML += '<li><a class="backbone-goto" data-goto="'+ el.ID +'">'+ el.post_title +'</a></li>';
          }
        });

        $('.remaining-items ul').html(remainingItemsHTML);
        

       if(count > 0) {
         $('.remaining-items-container').addClass('show-remaining-items');
         var $height = (parseInt($('.remaining-items').outerHeight())) + 22;
         $('.remaining-items').css("top", -$height + 'px');          
       }

      }
    }*/

    $('.remaining-items .close').on('click', function(){
      hideRemainingItemsPreview();
    }); 


    function hideRemainingItemsPreview() {
      $('.remaining-items-container').removeClass('show-remaining-items');
      $('.remaining-items').css("top", -250 + 'px');
    }

    //$('.slider-holder').before().click((e) => {});

    function updateSliderUI($id, $target, value) {

      $target.addClass('has-value');

      var $el = $('.backbone-element.backbone-block.active .selection-slider[data-id="'+ $id +'"]');

      switch(value){
        case 0:
          $el.find('.selection-slider__negative').removeClass('active');
          $el.find('.selection-slider__positive').addClass('active');
          break;
        case 1:
          $el.find('.selection-slider__negative').addClass('active');
          $el.find('.selection-slider__positive').removeClass('active');
          break;
      }

    }



         
    /*
     * Loop thru the elements and implement a rudementiary action
     */
    function loopThruBlocks(action) {
       for(var i = 0; i < backboneEls.length; i++) {
         action(i);  
       }
    }
    
    /*
     * Performs action on active block
     */
    function doActiveBlockAction(action) {
       let $currBlockID = $(activeBlock).data('id');
       loopThruBlocks(function(i) {
         if(backboneEls[i].ID == $currBlockID) {
           action(backboneEls[i]);
         }
       });
    }


  },
}


// WEBPACK FOOTER //
// ./scripts/routes/backbone.js